import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { antColors } from '@frontend/constants/colors';
import styles from './TruoraAlertCountStock.module.scss';

const TruoraAlertCountStock = ({ stock = 0 }) => {
  const getMsg = (count) =>
    count === 1
      ? `Recuerda que te queda ${count} Verificación de Antecedente.`
      : `Recuerda que te quedan ${count} Verificaciones de Antecedentes.`;

  return (
    <div className={styles.alert}>
      <FontAwesomeIcon icon={faTriangleExclamation} color={antColors.yellow3} />
      <span>
        <strong>{getMsg(stock)}</strong> Si deseas solicitar más información
        contáctate con tu ejecutivo comercial.
      </span>
    </div>
  );
};

export default TruoraAlertCountStock;
